// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"OMDgnVowO2YbD6gyQoWnm","infoWrapper":"_3SL7K5dMyEK0Z2mzLzIZ9c","iconWrapper":"_1B3S63wh5vs5x0Ag2B5CHX","textWrapper":"_3yQcneOys-rxdPY5IG-KkQ","title":"t2uKPGwXhkjhLYNmMdW1n","iconNext":"_2BQHTrWAH2tJiYAxLItAmT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdGoToForeignMainPage/AdGoToForeignMainPage.scss
// module id = 1558
// module chunks = 0